import config from "../../config";

export default {
  AUTH: {
    LOGIN: `${config.baseApiUrl}auth/login`,
    GOOGLE_LOGIN: `${config.baseApiUrl}auth/google`,
    GOOGLE_REGISTER: `${config.baseApiUrl}auth/google_register`,
    REFRESH: `${config.baseApiUrl}auth/refresh`,
    LOGOUT: `${config.baseApiUrl}auth/logout`,
  },
  ROLES: {
    GET_ROLES: `${config.baseApiUrl}roles`,
  },
  USER: {
    GET_USER_DETAILS: `${config.baseApiUrl}users/details`,
    GET_USERS: `${config.baseApiUrl}users`,
    GET_USER: (id: string) => `${config.baseApiUrl}users/${id}`,
    SYNC_USERS: `${config.baseApiUrl}users/sync`,
    SYNC_USERS_HOURS: `${config.baseApiUrl}users/sync_hours`,
    EXPORT_USERS_HOURS: `${config.baseApiUrl}users/export_hours`,
    CREATE_USER: `${config.baseApiUrl}users`,
    UPDATE_USER: (id: string) => `${config.baseApiUrl}users/${id}`,
    DELETE_USER: (id: string) => `${config.baseApiUrl}users/${id}`,
    GET_MEETINGS: `${config.baseApiUrl}meetings`,
    CREATE_MEETING: `${config.baseApiUrl}meetings`,
    UPDATE_MEETING: (id: string) => `${config.baseApiUrl}meetings/${id}`,
    DELETE_MEETING: (id: string) => `${config.baseApiUrl}meetings/${id}`,
    GET_ONBOARDINGS: `${config.baseApiUrl}onboardings`,
    GET_PROCEDURES: `${config.baseApiUrl}users/procedures`,
    GET_USER_SURVEYS: `${config.baseApiUrl}users/surveys`,
    CREATE_USER_SURVEY_ANSWERS: (id: string) => `${config.baseApiUrl}users/surveys/${id}/answer`,
    GET_USER_SURVEY: (id: string) => `${config.baseApiUrl}users/surveys/${id}`,
    GET_PROCESSES_WITH_PROCEDURES: `${config.baseApiUrl}processes/procedures`,
    ASSIGN_PROCEDURE: `${config.baseApiUrl}procedures/assign`,
    SELF_ASSIGN_PROCEDURE: `${config.baseApiUrl}procedures/assign_self`,
    ASSIGN_SURVEY: `${config.baseApiUrl}surveys/assign`,
    ASSIGN_ONBOARDING_TO_USER: `${config.baseApiUrl}onboardings/assign`,
    UPDATE_STATUS: (id: string) => `${config.baseApiUrl}users/${id}/status`,
    INVITE_USER: (id: string) => `${config.baseApiUrl}users/${id}/invite`,
    UPDATE_USER_PROCEDURE_STATUS: `${config.baseApiUrl}procedures/status`,
  },
  PROJECT: {
    GET_PROJECTS: `${config.baseApiUrl}projects`,
    CREATE_PROJECT: `${config.baseApiUrl}projects`,
    GET_WORK_TYPES: `${config.baseApiUrl}projects/work_types`,
    UPDATE_PROJECT: (id: string) => `${config.baseApiUrl}projects/${id}`,
    DELETE_PROJECT: (id: string) => `${config.baseApiUrl}projects/${id}`,
  },
  PROCEDURE: {
    GET_PROCEDURES: `${config.baseApiUrl}procedures`,
    GET_PROCEDURE: (id: string) => `${config.baseApiUrl}procedures/${id}`,
    SEMANTIC_SEARCH: `${config.baseApiUrl}procedures/semantic_search`,
    GET_PROCESSES: `${config.baseApiUrl}processes`,
    GET_PROCESSES_PROCEDURES: `${config.baseApiUrl}processes/procedures`,
    GET_TEAMS: `${config.baseApiUrl}teams`,
    CREATE_PROCEDURE: `${config.baseApiUrl}procedures`,
    UPDATE_PROCEDURE: (id: string) => `${config.baseApiUrl}procedures/${id}`,
    DELETE_PROCEDURE: (id: string) => `${config.baseApiUrl}procedures/${id}`,
    UPDATE_LAST_REVIEW_USER_PROCEDURE: `${config.baseApiUrl}procedures/update_last_review`,
    GET_USER_ONBOARDING_STEPS: `${config.baseApiUrl}onboardings/assigned/self`,
    UPDATE_USER_ONBOARDING_STATUS: (id: string) => `${config.baseApiUrl}onboardings/user-onboarding/${id}/status`,
  },
  SURVEY: {
    GET_SURVEYS: `${config.baseApiUrl}surveys`,
    GET_SURVEY: (id: string) => `${config.baseApiUrl}surveys/${id}`,
    CREATE_SURVEY: `${config.baseApiUrl}surveys`,
    UPDATE_SURVEY: (id: string) => `${config.baseApiUrl}surveys/${id}`,
    DELETE_SURVEY: (id: string) => `${config.baseApiUrl}surveys/${id}`,
    GET_SURVEY_STATISTIC: (id: string) => `${config.baseApiUrl}surveys/${id}/statistic`,
    GET_SURVEY_STATISTIC_DETAILS: (id: string) => `${config.baseApiUrl}surveys/${id}/statistic/details`,
    SEND_SURVEY: (id: string) => `${config.baseApiUrl}surveys/${id}/send`,
  },
  GOAL: {
    GET_GOALS: `${config.baseApiUrl}goals`,
    UPDATE_GOAL_PROGRESS: (id: string) => `${config.baseApiUrl}goals/${id}/progress`,
    CREATE_GOAL: `${config.baseApiUrl}goals`,
    UPDATE_GOAL: (id: string) => `${config.baseApiUrl}goals/${id}`,
    DELETE_GOAL: (id: string) => `${config.baseApiUrl}goals/${id}`,
  },
  RECOGNITION: {
    GET_RECOGNITIONS: `${config.baseApiUrl}recognitions`,
    GET_RECOGNITION: (id: string) => `${config.baseApiUrl}recognitions/${id}`,
    CREATE_RECOGNITION: `${config.baseApiUrl}recognitions`,
    UPDATE_RECOGNITION: (id: string) => `${config.baseApiUrl}recognitions/${id}`,
    DELETE_RECOGNITION: (id: string) => `${config.baseApiUrl}recognitions/${id}`,
    GET_CORE_VALUES: `${config.baseApiUrl}recognitions/core-values`,
    BULK_APPROVE: `${config.baseApiUrl}recognitions/bulk-approve`,
    // Phase 42: the Review tab's badge count. Gated server-side on VIEW_RECOGNITIONS *and* the
    // isReviewer role check (api/app/routes/recognitions.ts:232-244) -- the web-side gate mirrors the
    // role check, not the permission alone (923-core-context context/engineering/spark-rewards/phase-42-implementation-plan.md §0).
    GET_PENDING_COUNT: `${config.baseApiUrl}recognitions/pending-count`,
  },
  SPARKS: {
    // VIEW_RECOGNITIONS
    GET_SPARKS_SUMMARY: (userId: string) => `${config.baseApiUrl}recognitions/sparks-summary/${userId}`,
    // VIEW_BADGES -- a different permission from the summary above; see assertions 11/12.
    GET_USER_BADGES: (userId: string) => `${config.baseApiUrl}recognitions/badges/${userId}`,
    // VIEW_BADGES -- the full catalog, top-level (not nested under /recognitions); a plain string,
    // not a function, since there's no userId to parameterize.
    GET_BADGE_DEFINITIONS: `${config.baseApiUrl}badge-definitions`,
    // VIEW_LEADERBOARDS -- a plain string: query params (board/period/limit) are per-call, not
    // baked into the URL (923-core-context context/engineering/spark-rewards/phase-38-implementation-plan.md §2).
    GET_LEADERBOARD: `${config.baseApiUrl}recognitions/leaderboard`,
    // Phase 41: `/admin/redemptions`, NOT `/redemptions` -- the phase spec doc's curls are wrong
    // (plan §0). VIEW_REDEMPTIONS. The write that used to live at this same `admin/redemptions` path
    // (CREATE_REDEMPTION, MANAGE_REDEMPTIONS) was deleted in 923-core-context context/engineering/spark-rewards/phase-49-w5-org-wide-ledger.md alongside
    // the mark-consumed flow. The path is GET-only now, read by GET_REDEMPTION_LEDGER below and by
    // GET_USER_REDEMPTION_SUMMARY just below it.
    // 923-core-context context/engineering/spark-rewards/phase-49-w5-org-wide-ledger.md: this endpoint has existed since before this epic and web has
    // never called it until now.
    GET_REDEMPTION_LEDGER: `${config.baseApiUrl}admin/redemptions`,
    // Phase 41's original per-user read -- deleted web-side in phase-50-w6a alongside the Redemptions
    // tab's person picker ("the api route stays live server-side... but this repo no longer calls it").
    // 923-core-context context/engineering/spark-rewards/phase-55-person-sparks-drawer.md PR1 restores it: the person drawer needs one person's counters/
    // ledger/pendingRequests again, this time keyed off a ledger-row click rather than a picker.
    // VIEW_REDEMPTIONS, same gate as GET_REDEMPTION_LEDGER above.
    GET_USER_REDEMPTION_SUMMARY: (userId: string) => `${config.baseApiUrl}admin/redemptions/${userId}`,
    // phase-50-w6b: the three org-wide stat cards above the pending-requests panel (phase-50-a10).
    // VIEW_REDEMPTIONS, same gate as GET_REDEMPTION_LEDGER above -- a distinct URL, not a query param on
    // it, matching GET_REDEMPTION_REQUESTS/CREATE_REDEMPTION_REQUEST's own distinct-path precedent below.
    GET_REDEMPTION_STATS: `${config.baseApiUrl}admin/redemptions/stats`,
    // 923-core-context context/engineering/spark-rewards/phase-52-spread-your-sparks.md §4 S3: the "Spread your Sparks" section, viewer-scoped, no query
    // params (the window is a fixed server-side constant, not the board's own period selector) -- a
    // plain string, matching GET_LEADERBOARD/GET_GIVING_ACTIVITY's own no-param precedent above. Nested
    // under `recognitions/leaderboard/`, NOT a bare `leaderboard/collaborators` -- the router prefix on
    // `api/app/routes/recognitions.ts` is what makes GET_LEADERBOARD's own base path real too.
    GET_LEADERBOARD_COLLABORATORS: `${config.baseApiUrl}recognitions/leaderboard/collaborators`,
    // 923-core-context context/engineering/spark-rewards/phase-51-leaderboard-to-design.md L8 (api half): the "Your all-time" card's best-quarter/
    // first-Spark figures -- viewer-scoped, no query params, same no-param precedent as
    // GET_LEADERBOARD_COLLABORATORS just above, nested under the same `recognitions/leaderboard/` base.
    GET_ALL_TIME_SUMMARY: `${config.baseApiUrl}recognitions/leaderboard/all-time-summary`,
    // redeem-tab-plan.md PR1 §1b/§1c: the SELF-scoped counterpart, a top-level `/redemptions/:userId`
    // route -- anyone may read their own record, reading someone else's still needs VIEW_REDEMPTIONS
    // (enforced in the handler, not a route `pre` hook).
    GET_OWN_REDEMPTION_SUMMARY: (userId: string) => `${config.baseApiUrl}redemptions/${userId}`,
    // overview-rebuild-pr5-plan.md: VIEW_RECOGNITIONS, self-only -- the api derives the subject from
    // the token (no `:userId` segment), taking `tzOffsetMinutes` as a query param instead. A plain
    // string, matching GET_LEADERBOARD's own precedent above, not GET_SPARKS_SUMMARY's path-param style.
    GET_GIVING_ACTIVITY: `${config.baseApiUrl}recognitions/giving-activity`,
    // A4: VIEW_RECOGNITIONS, unpaginated -- a plain string, matching GET_BADGE_DEFINITIONS' own
    // precedent above (no userId to parameterize).
    GET_REWARD_ITEMS: `${config.baseApiUrl}rewards`,
    // 923-core-context context/engineering/spark-rewards/phase-49-w2-create-request.md: the employee-facing write against `POST /redemption-requests`
    // (A5) -- a NEW, top-level endpoint, distinct from the HR-gated admin/redemptions path (whose own
    // write took a client-supplied price and was deleted in 923-core-context context/engineering/spark-rewards/phase-49-w5-org-wide-ledger.md); this one
    // prices server-side from the catalog.
    CREATE_REDEMPTION_REQUEST: `${config.baseApiUrl}redemption-requests`,
    // 923-core-context context/engineering/spark-rewards/phase-49-w3-pending-requests-panel.md: the HR queue's own read -- a SEPARATE prefix from
    // CREATE_REDEMPTION_REQUEST above (`admin/redemption-requests`, not `redemption-requests`),
    // matching the api's own admin-redemption-requests.ts route file.
    GET_REDEMPTION_REQUESTS: `${config.baseApiUrl}admin/redemption-requests`,
    // 923-core-context context/engineering/spark-rewards/phase-49-w4-approve-deny.md: explicit sub-paths, not `PUT /:id` with a `{status}` body --
    // architecture §5.6's own reasoning ("illegal transitions unexpressible rather than merely
    // untested"). MANAGE_REDEMPTIONS, unlike GET_REDEMPTION_REQUESTS above (VIEW_REDEMPTIONS).
    APPROVE_REDEMPTION_REQUEST: (id: string) => `${config.baseApiUrl}admin/redemption-requests/${id}/approve`,
    DENY_REDEMPTION_REQUEST: (id: string) => `${config.baseApiUrl}admin/redemption-requests/${id}/deny`,
  },
  COMMENT: {
    GET_COMMENTS: `${config.baseApiUrl}comments`,
    CREATE_COMMENTS: `${config.baseApiUrl}comments`,
    UPDATE_COMMENT: (id: string) => `${config.baseApiUrl}comments/${id}`,
    DELETE_COMMENT: (id: string) => `${config.baseApiUrl}comments/${id}`,
  },
  CHART: {
    GET_CHART: `${config.baseApiUrl}chart`,
  },
  CHAT: {
    ASK_QUESTION: `${config.baseApiUrl}chat/ask`, // SSE — consumed by streamMessage.ts, not the axios client
    GET_LIST: `${config.baseApiUrl}chat`,
    GET_CHAT: (uuid: string) => `${config.baseApiUrl}chat/${uuid}`,
    UPDATE_CHAT: (uuid: string) => `${config.baseApiUrl}chat/${uuid}`,
    DELETE_CHAT: (uuid: string) => `${config.baseApiUrl}chat/${uuid}`,
    GET_STARTERS: `${config.baseApiUrl}chat/starters`,
    GET_QUOTA: `${config.baseApiUrl}chat/quota`,
    SEARCH: `${config.baseApiUrl}chat/search`,
    UPDATE_MESSAGE: (chatUuid: string, messageUuid: string) =>
      `${config.baseApiUrl}chat/${chatUuid}/messages/${messageUuid}`,
    // R06 — always 204 (a stop for a chat with nothing in progress, or a chat already finished, is a no-op).
    STOP_CHAT: (chatUuid: string) => `${config.baseApiUrl}chat/${chatUuid}/stop`,
  },
  EVALUATION: {
    GET_RUNS: `${config.baseApiUrl}admin/evals/runs`,
    SUBMIT_RUN: `${config.baseApiUrl}admin/evals/runs`,
    GET_RUN: (uuid: string) => `${config.baseApiUrl}admin/evals/runs/${uuid}`,
    DELETE_RUN: (uuid: string) => `${config.baseApiUrl}admin/evals/runs/${uuid}`,
    GET_DATASETS: `${config.baseApiUrl}admin/evals/datasets`,
  },
  PROCEDURE_INDEX: {
    GET_STATUS: `${config.baseApiUrl}admin/procedure-index/status`,
  },
  SETTINGS: {
    GET_SETTINGS: `${config.baseApiUrl}admin/settings`,
    UPDATE_SETTING: (key: string) => `${config.baseApiUrl}admin/settings/${key}`,
  },
  AUDIT_LOG: {
    GET_LIST: `${config.baseApiUrl}admin/audit-logs`,
    GET_FILTERS: `${config.baseApiUrl}admin/audit-logs/filters`,
    GET_DETAIL: (id: string) => `${config.baseApiUrl}admin/audit-logs/${id}`,
  },
  USAGE: {
    // 37-feature-usage-tracking.md Phase 2: fire-and-forget page-view beacon, signed-in only.
    TRACK_PAGE_VIEW: `${config.baseApiUrl}usage/page-views`,
  },
};
